(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function slugify(s) {
    return (s || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'section';
  }

  function init(root) {
    var content = root.querySelector('.gcp-content');
    var toc = root.querySelector('.gcp-toc');
    if (!content || !toc) return;

    var nav = toc.querySelector('.gcp-toc-nav');
    var bar = toc.querySelector('.gcp-toc-bar');

    // Use the page's primary heading level (h2 if present, else h3) so the nav
    // and prominent styling work regardless of how the page body was authored.
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < 2) {
      headings = Array.prototype.slice.call(content.querySelectorAll('h3'));
    }

    function closeMobile() {
      toc.classList.remove('is-open');
      if (bar) bar.setAttribute('aria-expanded', 'false');
    }

    if (headings.length < 2) {
      toc.parentNode.removeChild(toc);
      var body = root.querySelector('.gcp-body');
      if (body) body.classList.remove('gcp-has-toc');
      return;
    }

    var used = {};
    var byId = {};
    headings.forEach(function (h) {
      h.classList.add('gcp-section-head');
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        if (used[id]) { id = id + '-' + used[id]++; } else { used[id] = 1; }
        h.id = id;
      }
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      a.className = 'gcp-toc-link';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', location.pathname + '#' + id);
        }
        closeMobile();
      });
      nav.appendChild(a);
      byId[id] = a;
    });

    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            Object.keys(byId).forEach(function (k) { byId[k].classList.remove('is-active'); });
            if (byId[en.target.id]) byId[en.target.id].classList.add('is-active');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      headings.forEach(function (h) { spy.observe(h); });
    }

    if (bar) {
      bar.addEventListener('click', function () {
        var open = toc.classList.toggle('is-open');
        bar.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.galore-content-page');
    Array.prototype.forEach.call(roots, function (r) {
      if (r.dataset.gcpInit) return;
      r.dataset.gcpInit = '1';
      init(r);
    });
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
      const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
